import { seoContent } from '@/mocks/seoContent';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[550px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20product%20display%20arrangement%20with%20curated%20fashion%20pieces%20and%20lifestyle%20accessories%20on%20light%20travertine%20textured%20surface%20golden%20afternoon%20sunlight%20streaming%20diagonally%20creating%20rich%20warm%20highlights%20and%20soft%20shadows%20elegant%20minimalist%20editorial%20style%20cozy%20sophisticated%20atmosphere%20cream%20caramel%20and%20bronze%20tones&width=1920&height=1080&seq=cta-bg-v3&orientation=landscape"
          alt="OOPBuy Spreadsheet shopping experience"
          title="Start Using OOPBuy Spreadsheet Today"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full section-container">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-extrabold text-background-50 leading-tight tracking-tight uppercase">
            {seoContent.ctaTitle}
          </h2>
          <p className="mt-6 text-background-50/80 text-sm md:text-base leading-relaxed">
            {seoContent.ctaSubtitle}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="btn-primary px-8 py-4 text-sm inline-flex items-center gap-2"
            >
              <span className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line text-background-50 text-sm"></i>
              </span>
              <span>Get Started Now</span>
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="/article/what-is-oopbuy-spreadsheet"
              className="flex items-center gap-2 text-background-50/80 hover:text-background-50 text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-text-line"></i>
              Open Spreadsheet Guide
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}